module.exports = "<style>\r\n\tbody { background: linear-gradient(-90deg, #6b4bb7 0%,#177da6 100%); }\r\n</style>\r\n<section class=\"page page-{{$index + 1}}\" ng-repeat=\"page in vm.pages\" ng-class=\"{ current: vm.current === $index + 1 }\">\r\n\t<div class=\"content\" ng-include=\"page.content\">\r\n\t</div>\r\n\t<div class=\"bg\" style=\"{{vm.format(page.bg)}}\">\r\n\t</div>\r\n</section>\r\n<div class=\"preload\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/index/index.template.html
// module id = 20
// module chunks = 0